import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { useFetch } from '../useFetch'
import { useLogout } from '../auth/useLogout'

import { CONFIG } from '../../config'
import { useAuth } from '../../contexts/AuthContext'
import { ApiError } from '../../types/exception/errorStatus'
import { getErrorMessage } from '../../utils/exception/exceptionUtils'

export function useDeleteAccount() {
  const { t } = useTranslation(['auth', 'exceptions'])
  const [loading, setLoading] = useState(false)
  const [success, setSuccess] = useState<string | null>(null)
  const [error, setError] = useState<string | null>(null)
  const { authInfo } = useAuth()
  const { deleter } = useFetch(authInfo?.accessToken, authInfo?.refreshToken)
  const { clearSession } = useLogout()

  const resetState = () => {
    setLoading(false)
    setError(null)
    setSuccess(null)
  }

  const deleteAccount = async () => {
    setLoading(true)
    try {
      await deleter(`${CONFIG.BOUNCE_API}/api/v1/account`)
      setSuccess(t('auth:account.successfully-deleted'))
      setError(null)
      clearSession()
      return true
    } catch (error) {
      console.log(error)
      let message: string

      if (error instanceof ApiError) {
        message = getErrorMessage(error.data)
      } else {
        message = t('exceptions:unknown')
      }

      setError(message)
      throw new Error(message)
    } finally {
      setLoading(false)
    }
  }

  return { deleteAccount, loading, error, success, resetState }
}
